// removed by extract-text-webpack-plugin
module.exports = {"wrap-nav-top":"wrap-nav-top","logo":"logo","logo-img":"logo-img"};


//////////////////
// WEBPACK FOOTER
// ./components/layouts/master/sub-header/_Logo.scss
// module id = ./components/layouts/master/sub-header/_Logo.scss
// module chunks = 0